import { render, staticRenderFns } from "./deleteGroupModal.vue?vue&type=template&id=1f03886b&scoped=true"
import script from "./deleteGroupModal.vue?vue&type=script&lang=js"
export * from "./deleteGroupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f03886b",
  null
  
)

export default component.exports